// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"221":"26acabf1","672":"abb84799"}[chunkId] + ".chunk.js";
};